import React, { memo } from "react";
import { IconButton, IconButtonProps } from "@mui/material";

const CustomIconButton = memo((props: IconButtonProps) => {
  return <IconButton {...props} />;
});

export { CustomIconButton };
